import { defineComponent } from 'vue';
import productBox from '@/components/Blue/ProductBox.vue';
import { blueProductsApiClient } from '@/services/api';
export default defineComponent({
    name: 'deal-products-wrapper',
    components: { productBox },
    props: {
        bigBox: {
            type: Boolean,
            required: false,
            default: false,
        },
        dealSection: {
            type: null,
            required: false,
            default: null,
        },
        categoryId: {
            type: null,
            required: false,
            default: null,
        },
        loadSize: {
            type: Number,
            required: false,
            default: 8,
        },
    },
    methods: {
        showMore() {
            ++this.page;
            blueProductsApiClient
                .getDeals(this.page, this.loadSize, this.dealSection, this.categoryId)
                .then((response) => {
                this.products.push(...response.products);
            });
        },
    },
    data() {
        return {
            products: [],
            page: 1,
            total: 0,
        };
    },
    mounted() {
        blueProductsApiClient.getDeals(this.page, this.loadSize, this.dealSection, this.categoryId).then((response) => {
            this.products.push(...response.products);
            this.total = response.total;
        });
    },
});
